<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="message-card" v-if="showNewsSection">
				<div class="header">
					<div class="tabbar">
						<div class="item" @click="textClick(index)" :class="{ active: count == index }" v-for="(item, index) in newsTabList" :key="item.menuId">
							<div class="txt">{{ item.menuName }}</div>
							<div class="line"></div>
						</div>
					</div>
					<div class="more" @click="moreClick()">{{ $t('common.more') }}></div>
				</div>
				<div class="list">
					<div class="item" v-for="(item, index) in textList" @click="contentClick(item.id)">
						<div class="title txt-ellipsis-2">{{ item.contentTitle }}</div>
						<div class="date" v-if="item.createTime">{{ $t('common.updateDate') }} {{ item.createTime.slice(0, 10) }}</div>
					</div>
				</div>
			</div>
			<div class="project-list">
				<div class="header">
					<div class="item active">
						<div class="txt">{{ $t('home.engineering') }}</div>
						<div class="line"></div>
					</div>
				</div>
				<div class="list-wrapper" v-for="(classificationItem, classificationIndex) in engineeringListClassification" :key="classificationIndex">
					<div class="title">{{ classificationItem.title }}</div>
					<div class="list">
						<div class="item" v-for="(item, index) in classificationItem.list" :key="item.id" @click="vocationalClick(item)">
							<img :src="webImg + item.contentImg + imgCut(345, 242)" alt="" @dragstart.prevent />
							<div class="item-title txt-ellipsis-2">{{ filterUnit(item.title) }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="home">
				<div class="content" v-if="showNewsSection">
					<div class="left" style="width: 650px">
						<el-carousel trigger="click" height="386px" indicator-position="none">
							<el-carousel-item v-for="(item, index) in textImgList" :key="index">
								<div style="position: relative; cursor: pointer">
									<img
										:src="webImg + item.contentImg + imgCut(650, 356)"
										alt=""
										srcset=""
										@dragstart.prevent
										style="width: 650px;!important; height: 386px;"
										@click="contentClick(item.id)"
									/>
									<div class="leftText">
										<div>{{ filterUnit(item.contentTitle) }}</div>
									</div>
								</div>

								<!-- <div class="leftText">1111</div> -->
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="right">
						<div class="newContent">
							<div class="text">
								<div class="textItem" @click="textClick(index)" :class="{ textItem1: count == index }" v-for="(item, index) in newsTabList" :key="item.menuId">{{ item.menuName }}</div>
							</div>

							<div class="more" @click="moreClick()">{{ $t('common.moreShort') }}</div>
						</div>

						<div class="newMain">
							<div class="newMainItem" v-for="(item, index) in textList" @click="contentClick(item.id)">
								<div class="newMainDescription">{{ filterUnit(item.contentTitle) }}</div>
								<div class="time" v-if="item.createTime">[{{ item.createTime.slice(0, 10) }}]</div>
							</div>
						</div>
					</div>
				</div>

				<div class="engineering">
					<div class="engineeringName">
						<div>{{ businessAreaTitle }}</div>
						<div class="line"></div>
					</div>
					<div class="engineeringMain-wrapper" v-for="(classificationItem, classificationIndex) in engineeringListClassification" :key="classificationIndex">
						<div class="title">{{ classificationItem.title }}</div>
						<div class="engineeringMain">
							<div class="engineeringMainItem" v-for="(item, index) in classificationItem.list" :key="item.id" @click="vocationalClick(item)">
								<div class="item-img-wrap">
									<img :src="webImg + item.contentImg + imgCut(310, 225)" alt="" @dragstart.prevent />
								</div>
								<div class="item-title txt-ellipsis-2">{{ filterUnit(item.title) }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { contentPage, businessList, menu, menuAll } from '../api/api';
import { buildBusinessGroups, filterCategorizedBusinessList } from '../utils/businessCategory';
import { buildCmsLocation, findNavByType, attachNavMeta, resolveHomeNewsTabs } from '../utils/cmsNav';
import { mapGetters } from 'vuex';
export default {
	name: 'homeTemplate',
	data() {
		return {
			newsList: [],
			textImgList: [],
			count: 0,
			textList: [],
			newsTabList: [],
			businessNavId: '',
			businessAreaTitle: '',
			engineeringList: [],
			engineeringGroups: []
		};
	},
	computed: {
		...mapGetters(['isMobile', 'locale']),
		engineeringListClassification() {
			return this.engineeringGroups;
		},
		showNewsSection() {
			return this.newsTabList.length > 0;
		}
	},
	created() {
		this.loadData();
		this.$bus.$on('localeChanged', this.loadData);
	},
	beforeDestroy() {
		this.$bus.$off('localeChanged', this.loadData);
	},
	watch: {
		locale() {
			this.rebuildBusinessGroups();
		}
	},
	methods: {
		loadData() {
			this.loadBusinessAreaTitle();
			this.getNewsTabs();
			this.getVocationalList();
		},
		loadBusinessAreaTitle() {
			return menuAll(true).then((res) => {
				const navList = (res.data || []).map(attachNavMeta);
				const businessNav = findNavByType(navList, 'business');
				this.businessNavId = businessNav ? businessNav.menuId : '';
				this.businessAreaTitle = businessNav ? businessNav.menuName : '';
			});
		},
		rebuildBusinessGroups() {
			this.engineeringGroups = buildBusinessGroups(this.engineeringList, this.locale);
		},
		getVocationalList() {
			businessList({ showHome: 1 }).then((res) => {
				this.engineeringList = filterCategorizedBusinessList(res.data || []);
				this.rebuildBusinessGroups();
			});
		},
		vocationalClick(item) {
			this.openUrl(
				buildCmsLocation({
					parentId: this.businessNavId,
					id: item.id,
				})
			);
		},
		getNewsTabs() {
			resolveHomeNewsTabs(() => menuAll(), this.locale).then((tabs) => {
				this.newsTabList = tabs;
				if (!this.newsTabList.length) {
					this.textList = [];
					this.textImgList = [];
					this.count = 0;
					return;
				}
				if (this.count >= this.newsTabList.length) {
					this.count = 0;
				}
				this.getNewsPage(this.newsTabList[this.count].menuId);
				this.getNewImgPage(this.newsTabList[0].menuId);
			});
		},
		filterUnit(item) {
			return (item || '').replace(/<br>/g, '');
		},

		newsImgClick() {
			console.log(1111111);
		},
		//
		textClick(index) {
			this.count = index;
			if (this.newsTabList[index]) {
				this.getNewsPage(this.newsTabList[index].menuId);
			}
		},
		//新闻动态
		contentClick(id) {
			const tab = this.newsTabList[this.count];
			this.openUrl(
				buildCmsLocation({
					parentId: tab && tab.parentId,
					menuId: tab && tab.menuId,
					contentId: id,
				})
			);
		},
		moreClick() {
			const tab = this.newsTabList[this.count];
			this.openUrl(
				buildCmsLocation({
					parentId: tab && tab.parentId,
					menuId: tab && tab.menuId,
				})
			);
		},
		getNewsPage(id) {
			contentPage(1, 9, id, '', 1).then((res) => {
				this.textList = res.data;
			});
		},
		getNewImgPage(id) {
			contentPage(1, 5, id, '', 1, '', 1).then((res) => {
				this.textImgList = res.data.filter((item) => item.contentImg);
			});
		},
		getImg(list) {
			if (list && list.length > 0) {
				let arrList = [];
				list.forEach((item, index) => {
					if (item.contentImg) {
						arrList.push(item);
					}
				});
				return arrList;
			} else {
				return [];
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.device-mobile {
	.message-card {
		width: 9.466667rem;

		.header {
			width: 100%;
			height: 1.653333rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.tabbar {
				display: flex;
				align-items: center;

				.item {
					position: relative;
					display: flex;
					flex-direction: column;
					margin-right: 0.4rem;

					&.active {
						.txt {
							font-size: 0.453333rem;
							font-weight: bold;
							color: #000000;
						}

						.line {
							display: block;
						}
					}

					.txt {
						font-size: 0.4rem;
						font-weight: 400;
						color: #000000;
					}

					.line {
						position: absolute;
						bottom: -0.266667rem;
						display: none;
						margin-top: 0.213333rem;
						width: 1.2rem;
						height: 0.053333rem;
						background: #007cc3;
						border-radius: 0px 0px 0px 0px;
						opacity: 1;
					}
				}
			}

			.more {
				font-size: 0.346667rem;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #007cc3;
				cursor: pointer;
			}
		}

		.list {
			width: 100%;
			background: #ffffff;
			box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
			border-radius: 0px 0px 0px 0px;
			opacity: 1;

			.item {
				width: 100%;
				box-sizing: border-box;
				padding: 0.4rem;
				border-bottom: 0.026667rem solid #eeeeee;

				.title {
					font-size: 0.4rem;
					// font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: 400;
					color: #333333;
					line-height: 0.533333rem;
				}

				.date {
					margin-top: 0.266667rem;
					font-size: 0.266667rem;
					// font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: 400;
					color: #666666;
				}
			}
		}
	}

	.project-list {
		width: 9.466667rem;

		.header {
			width: 100%;
			height: 1.653333rem;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.item {
				position: relative;
				display: flex;
				flex-direction: column;
				margin-right: 0.4rem;

				&.active {
					.txt {
						font-size: 0.453333rem;
						font-weight: bold;
						color: #000000;
					}

					.line {
						display: block;
					}
				}

				.txt {
					font-size: 0.4rem;
					font-weight: 400;
					color: #000000;
				}

				.line {
					position: absolute;
					bottom: -0.266667rem;
					display: none;
					margin-top: 0.213333rem;
					width: 1.2rem;
					height: 0.053333rem;
					background: #007cc3;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
				}
			}
		}

		.list-wrapper {
			display: flex;
			flex-direction: column;
			margin-bottom: 0.6rem;

			.title {
				font-size: 0.4rem;
				font-weight: bold;
				color: #000000;
				margin-bottom: 0.4rem;
			}

			&:not(:first-child) .title {
				margin-top: 0.4rem;
			}
			.list {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.item {
					display: flex;
					flex-direction: column;
					align-items: center;
					width: 4.6rem;
					margin-bottom: 0.266667rem;
					text-decoration: none;
					cursor: pointer;

					img {
						width: 4.6rem;
						height: 3.226667rem;
						flex-shrink: 0;
						object-fit: cover;
					}

					.item-title {
						width: 100%;
						margin: 0.266667rem 0;
						font-size: 0.346667rem;
						font-family: Microsoft YaHei-Regular, Microsoft YaHei;
						font-weight: 400;
						color: #004ea1;
						text-align: center;
						line-height: 1.4;
						min-height: calc(0.346667rem * 1.4 * 2);
					}
				}
			}
		}
	}
}

.device-pc {
	.home {
		
	}

	.left {
		overflow: hidden;

		.leftText {
			position: absolute;
			bottom: 0;
			width: 100%;
			height: 40px;

			div {
				width: 500px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				-o-text-overflow: ellipsis;
				text-align: center;
				// display: flex;
				// justify-content: center;
				// align-items: center;
			}

			font-size: 16px;
			font-weight: normal;
			color: white;
			display: flex;
			justify-content: center;
			align-items: center;
			background: rgba(0, 0, 0, 0.4);
		}
	}

	.content {
		width: 1300px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		padding-bottom: 20px;
		margin-top: 80px;
		// justify-content: center;
	}

	.right {
		width: 650px;
		height: 386px;
		// height: 485px;
		// box-shadow: -5px 4px 5px 0px rgba(153, 153, 153, 1);
		box-sizing: border-box;
		border: 1px solid #e6e3e3;
		border-left: none;
		box-sizing: border-box;

		.newContent {
			height: 49px;
			border-bottom: 1px solid #e6e3e3;
			display: flex;
			align-items: center;
			padding: 0 20px;
			box-sizing: border-box;
		}

		.text {
			display: flex;
			align-items: center;

			.textItem {
				font-size: 20px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: 600;
				color: #333333;
				cursor: pointer;
			}

			.textItem:first-child {
				margin-right: 48px;
			}

			.textItem1 {
				font-size: 20px;
				font-weight: 600;
				color: #0175c2;
			}
		}

		.more {
			font-size: 14px;
			font-weight: 600;
			color: #b6b6b6;
			margin-left: auto;
			margin-top: 5px;
			cursor: pointer;
		}

		.newMain {
			padding: 0 20px;
			box-sizing: border-box;

			.newMainItem {
				height: 36px;
				color: #333333;
				width: 700px;
				// text-indent: 20px;
				display: block;
				line-height: 36px;
				font-size: 17px;

				display: flex;
				align-items: center;
				cursor: pointer;

				.newMainDescription {
					width: 500px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				.time {
					// font-size: 13px;
					// font-weight: 600;
					// color: #000000;
					margin-left: 20px;
				}
			}
		}
	}

	.engineering {
		width: 1920px;
		// height: 1393px;
		background: #f5f5f5;

		.engineeringName {
			font-size: 26px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #333;
			display: flex;
			flex-direction: column;
			align-items: center;
			height: 130px;
			justify-content: center;

			.line {
				width: 55px;
				height: 2px;
				background: #c2c2c2;
				margin-top: 10px;
			}
		}
	}

	.engineeringMain-wrapper {
		display: flex;
		flex-direction: column;
		margin-bottom: 10px;

		&:last-child {
			margin-bottom: 20px;
		}

		.title {
			width: 1300px;
			margin: 0 auto;
			font-size: 20px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #333;
			margin-bottom: 20px;
		}

		&:not(:first-child) .title {
			margin-top: 20px;
		}
		.engineeringMain {
			display: flex;
			flex-wrap: wrap;
			width: 1300px;
			margin: 0 auto;
			column-gap: 20px;
			row-gap: 50px;

			a {
				color: #004ea1;
				text-decoration: none;
				text-align: center;
			}

			.engineeringMainItem {
				width: 310px;
				flex-shrink: 0;
				font-size: 20px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #004ea1;
				display: flex;
				flex-direction: column;
				align-items: center;
				cursor: pointer;

				.item-img-wrap {
					width: 310px;
					height: 225px;
					margin-bottom: 20px;
					flex-shrink: 0;
					overflow: hidden;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
					}
				}

				.item-title {
					width: 100%;
					text-align: center;
					line-height: 1.4;
					min-height: calc(20px * 1.4 * 2);
					word-break: break-word;
				}
			}

			.engineeringMainItem:hover {
				.item-img-wrap img {
					transform: scale(1.1);
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue